import { AxiosResponse } from 'axios';
import { csrfToken, getCsrfToken, getCsrfTokenOnCookie, instance } from '../db';
import {
  Co2SettingGetType,
  Co2SettingListType
} from '../../validation/co2Setting/co2SettingType';

// CO2基準値取得API
export const getCo2Setting = async (
  co2_setting_id?: string
): Promise<Co2SettingGetType> => {
  await getCsrfToken();

  if (co2_setting_id) {
    const response = await instance.get(`/co2_settings/${co2_setting_id}`, {
      headers: {
        'X-XSRF-TOKEN': csrfToken
      }
    });
    return response.data;
  }

  const response = await instance.get('/co2_settings', {
    headers: {
      'X-XSRF-TOKEN': csrfToken
    }
  });
  return response.data;
};

// CO2基準値既読API
export const readCo2Setting = async (
  co2_setting_id?: number
): Promise<void> => {
  const csrftoken = await getCsrfTokenOnCookie();
  if (!co2_setting_id) {
    await instance.put(
      `/co2_settings/read`,
      {},
      {
        headers: {
          'X-XSRF-TOKEN': csrftoken
        }
      }
    );
  }

  await instance.put(
    `/co2_settings/read`,
    { co2_setting_id: co2_setting_id },
    {
      headers: {
        'X-XSRF-TOKEN': csrftoken
      }
    }
  );
};

// CO2基準値新規保存API
export const saveCo2Setting = async (
  name: string,
  useFlg: number,
  co2SettingValues: {
    material_id: number;
    value: number;
    remark: string | null;
  }[]
): Promise<Co2SettingGetType> => {
  const csrftoken = await getCsrfTokenOnCookie();

  const response = await instance.post(
    `/co2_settings`,
    {
      name: name,
      use_flg: useFlg,
      co2_setting_values: co2SettingValues
    },
    {
      headers: {
        'X-XSRF-TOKEN': csrftoken
      }
    }
  );

  return response.data;
};

// CO2基準値上書き保存API
export const updateCo2Setting = async (
  id: string,
  name: string,
  useFlg: number,
  co2SettingValues: {
    material_id: number;
    value: number;
    remark: string | null;
  }[]
): Promise<Co2SettingGetType> => {
  await getCsrfToken();

  const response = await instance.put(
    `/co2_settings/${id}`,
    {
      name: name,
      use_flg: useFlg,
      co2_setting_values: co2SettingValues
    },
    {
      headers: {
        'X-XSRF-TOKEN': csrfToken
      }
    }
  );

  return response.data;
};

// CO2基準値削除API
export const deleteCo2Setting = async (id: number): Promise<void> => {
  const csrftoken = await getCsrfTokenOnCookie();
  await instance.delete(`/co2_settings/${id}`, {
    headers: {
      'X-XSRF-TOKEN': csrftoken
    }
  });
};

// 保存したCO2基準値取得API
export const getCo2SettingList = async (): Promise<Co2SettingListType[]> => {
  await getCsrfToken();

  const response = await instance.get('/co2_settings/list/', {
    headers: {
      'X-XSRF-TOKEN': csrfToken
    }
  });

  return response.data;
};

// CO2基準値利用パターン変更API
export const changeCo2SettingPattern = async (
  id: number
): Promise<AxiosResponse> => {
  const csrftoken = await getCsrfTokenOnCookie();
  const response = await instance.put(
    `/co2_settings/${id}/patern_change`,
    {},
    {
      headers: {
        'X-XSRF-TOKEN': csrftoken
      }
    }
  );
  return response;
};
